import template from './batch.create.html';
import controller from './batch.create.controller';
import './batch.create.controller';

let batchcreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default batchcreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/batch/create/batch.create.component.js